export default {
  viewBox: "0 0 24 24",
  paths: [
    "M0 11L22 11L22 13L-3.49691e-07 13L0 11Z",
    "M17.3833 18L16 16.7458L21.2352 12L16 7.25423L17.3833 6L24 12L17.3833 18Z"
  ]
};